import { getElements } from "@oddcamp/js-utils/src/selector";
import { getOffset } from "@oddcamp/js-utils/src/position";
import { debounce } from "@oddcamp/js-utils/src/function";

// scroll to the current item in a horizontal-scroll container

const init = () => {
  var paginations = getElements(".pagination ul");
  if (!paginations.length) return;

  const centerOnActiveItem = (pagination) => {
    const item = pagination.querySelector(".\\--current");
    if (!item) return;
    const pos =
      pagination.scrollLeft +
      getOffset(item).left -
      getOffset(pagination).left -
      pagination.offsetWidth / 2 +
      item.offsetWidth / 2;
    pagination.scrollLeft = pos;
  };

  paginations.forEach((pagination) => {
    window.addEventListener(
      "resize",
      debounce(300, () => {
        centerOnActiveItem(pagination);
      })
    );

    centerOnActiveItem(pagination);
  });
};

if (typeof Turbolinks !== "undefined") {
  document.addEventListener("turbolinks:load", init);
} else {
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
}
